import {Injectable} from '@angular/core';
import {BackendService} from "./backend.service";
import {forkJoin, Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class FileService {
    private urlPrefix = '/api/file';

    constructor(private backend: BackendService) {
    }

    /**
     * Método para registrar la propiedad direccion
     * @param file
     */
    paperFileCreate(file: any): Observable<any> {
        return this.backend.post(this.urlPrefix, file).pipe(
            map(response => response)
        );
    }

    /**
     * Sube un archivo PDF a una propiedad específica
     * @param propertyId ID de la propiedad
     * @param paperId ID del documento asociado
     * @param file Archivo PDF a subir
     * @returns Observable con la respuesta del backend
     */
    /**
     * Sube un archivo PDF al backend
     */
    uploadPaperFile(propertyId: any, paperId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);

        const url = `${this.urlPrefix}/property/${propertyId}/paper/${paperId}`;
        return this.backend.post(url, formData).pipe(map(response => response.response));
    }

    /**
     * Elimina un archivo subido
     * @param fileId ID del archivo a eliminar
     * @returns Observable con la respuesta del backend
     */
    deleteFile(fileId: any): Observable<any> {
        const url = `${this.urlPrefix}/${fileId}`;
        return this.backend.delete(url).pipe(map(response => response.response));
    }

    /**
     * Sube múltiples imágenes para una característica específica de una propiedad.
     */
    uploadImage(propertyId: any, featureId: number, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', new Blob([file], { type: file.type }), file.name); // Forzamos el tipo de archivo

        console.log('FormData contenido:', formData.get('file')); // Verificar que el archivo se agrega correctamente

        const url = `${this.urlPrefix}/property/${propertyId}/feature/${featureId}`;
        return this.backend.postFile(url, formData).pipe(map(response => response.response));
    }




    getImagesForProperty(propertyId: number, featureId: number): Observable<any>{
        const url = `${this.urlPrefix}/property/${propertyId}/feature/${featureId}`;
        return this.backend.get(url).pipe(map(response => response.response));
    }

    putFileFirst(fileId:any): Observable<any>{
        const url = `${this.urlPrefix}/main`;
        return this.backend.put(url, fileId).pipe(map(response => response.response));
    }
    putFileName(fileId: number, data:any): Observable<any>{
        const url = `${this.urlPrefix}/title/${fileId}`;
        return this.backend.put(url, data).pipe(map(response => response.response));
    }
}
